import React from 'react'
import { useAppDispatch } from 'store/hooks'
import { actions as accountActions } from 'store/account'
import { useNavigate } from 'react-router-dom'
import { ReactComponent as Logo } from 'assets/images/insights-IDS.svg'
import TipsAndUpdatesIcon from '@mui/icons-material/TipsAndUpdates'
import MenuIcon from '@mui/icons-material/Menu'
import QueryStatsIcon from '@mui/icons-material/QueryStats'
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings'
import TableViewIcon from '@mui/icons-material/TableView'
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined'
import EditNoteIcon from '@mui/icons-material/EditNote'
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined'
import AssessmentIcon from '@mui/icons-material/Assessment'
import LogoutIcon from '@mui/icons-material/Logout'
import SettingsIcon from '@mui/icons-material/Settings'
import { List, Divider, IconButton, Box } from '@mui/material'
import { RootState } from 'store'
import { useSelector } from 'react-redux'
import { StyledDrawer, StyledDrawerHeader } from './SidebarStyles'
import SidebarItem from './SideBarItem'
import SidebarSection from './SidebarSection'

export default function Sidebar() {
  const roles = useSelector((state: RootState) => state.account.roles)
  const [open, setOpen] = React.useState(true)
  const dispatch = useAppDispatch()
  const history = useNavigate()
  const logOut = (ev: React.MouseEvent) => {
    dispatch(accountActions.logout())
    history(`/`)
  }
  const accountSections = [
    {
      title: 'My account',
      items: [
        {
          text: 'Settings',
          path: '/settings/security',
          icon: <SettingsIcon />,
        },
        {
          text: 'Log out',
          path: 'logout',
          onClick: logOut,
          icon: <LogoutIcon />,
        },
      ],
    },
  ]
  const sidebarSections = [
    {
      items: [
        {
          text: 'My dashboard',
          path: '/dashboard/reporting',
          icon: <DashboardOutlinedIcon />,
        },
      ],
    },
    {
      title: 'Create search',
      items: [
        {
          text: 'with Company name',
          path: '/company/search',
          icon: <QueryStatsIcon />,
        },
        {
          text: 'with Single Patent',
          path: '/report',
          icon: <EditNoteIcon />,
        },
      ],
    },
    {
      title: 'My reports',
      items: [
        {
          text: 'Company reports',
          path: '/dashboard/reporting/company',
          icon: <TableViewIcon />,
        },
        {
          text: 'Single patent reports',
          path: '/dashboard/reporting/single-search',
          icon: <ArticleOutlinedIcon />,
        },
        {
          text: 'Benchmark reports',
          path: '/dashboard/reporting/benchmark',
          icon: <AssessmentIcon />,
        },
      ],
    },
  ]
  const drawerTxtColor = 'rgb(204, 204, 204)'
  const drawerActiveTxtColor = 'white'

  return (
    <StyledDrawer variant="permanent" open={open}>
      <StyledDrawerHeader>
        <IconButton onClick={() => setOpen(!open)}>
          <MenuIcon
            fontSize="large"
            sx={{
              pl: 1,
              mr: -1,
              color: drawerTxtColor,
              '&:hover': {
                color: drawerActiveTxtColor,
              },
            }}
          />
        </IconButton>
        {open && <Logo height={'55'} width={'100%'} />}
      </StyledDrawerHeader>

      <Divider />
      <Box sx={{ px: 0.5, py: 2 }}>
        <List>
          {sidebarSections.map((section, index) => (
            <SidebarSection
              key={index}
              section={section}
              open={open}
              drawerTxtColor={drawerTxtColor}
              drawerActiveTxtColor={drawerActiveTxtColor}
            />
          ))}
          {roles?.includes('bo_admin') && (
            <>
              <Divider sx={{ m: 2, borderColor: drawerTxtColor }} />
              <SidebarItem
                path="/settings/admin"
                text="Admin Area"
                icon={<AdminPanelSettingsIcon />}
                open={open}
                drawerTxtColor={drawerTxtColor}
                drawerActiveTxtColor={drawerActiveTxtColor}
              />
            </>
          )}

          <SidebarItem
            path="/resources"
            text="Resources"
            icon={<TipsAndUpdatesIcon />}
            open={open}
            drawerTxtColor={drawerTxtColor}
            drawerActiveTxtColor={drawerActiveTxtColor}
          />

          <Box height={20}></Box>
          {accountSections.map((section, index) => (
            <SidebarSection
              key={index}
              section={section}
              open={open}
              drawerTxtColor={drawerTxtColor}
              drawerActiveTxtColor={drawerActiveTxtColor}
            />
          ))}
        </List>
        <Divider />
      </Box>
    </StyledDrawer>
  )
}
